import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePortal } from "@/context/PortalContext";
import { useI18n } from "@/context/I18nContext";
import { Card, Loader } from "@/components/portal/ui";
import { StatusBadge } from "@/components/portal/StatusBadge";

// Optional jobs module — provider/manager view of applications to their jobs.
export function JobApplications() {
  const { portalKey } = usePortal();
  const { L } = useI18n();
  const [apps, setApps] = useState(null);

  useEffect(() => { api.get("/applications").then(({ data }) => setApps(data)).catch(() => setApps([])); }, [portalKey]);

  if (!apps) return <Loader />;
  if (apps.length === 0) return <Card className="p-8 text-center text-sm" style={{ color: "var(--text-muted)" }}>{L({ de: "Noch keine Bewerbungen.", fr: "Aucune candidature.", it: "Nessuna candidatura.", en: "No applications yet." })}</Card>;

  return (
    <div className="space-y-3" data-testid="job-applications">
      {apps.map((a) => (
        <Card key={a.id} className="p-4 flex items-start gap-3" data-testid={`application-row-${a.id}`}>
          <div className="min-w-0 flex-1">
            <div className="font-semibold truncate" style={{ color: "var(--text)" }}>{a.candidate_name}</div>
            <div className="text-xs" style={{ color: "var(--text-muted)" }}>{a.job_title}</div>
            {a.message && <div className="text-sm mt-1.5" style={{ color: "var(--text)" }}>{a.message}</div>}
          </div>
          <StatusBadge status={a.status} />
        </Card>
      ))}
    </div>
  );
}
